import * as Scrivito from "scrivito";

import blogObjIcon from "assets/images/blog_obj.svg";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("WizardList", {
  title: "Wizards",
  thumbnail: blogObjIcon,
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
    wizardItem: {
      title: "Wizards",
    },
  },
  properties: [...defaultPageProperties],
  propertiesGroups: [
    {
      title: "Wizards",
      properties: ["wizardItem"],
    },
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Wizards",
    subtitle: "Overview",
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "wizardItem",
      (wizardItemArr) => {
        const typesArr = wizardItemArr.map((wizard) => wizard.get("subType"));
        if (
          typesArr.some((x) => typesArr.indexOf(x) !== typesArr.lastIndexOf(x))
        ) {
          return {
            message: "Wizard type must be unique.",
            severity: "error",
          };
        }
      },
    ],
    [
      "images",
      (images) => {
        if (!images.length) {
          return {
            message: "Images should be set.",
            severity: "error",
          };
        }
      },
    ],
  ],
});
